import { createContext } from 'react'

const previewContext = createContext({
    // survey live props
    onPreview: () => {}
})

export default previewContext